'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = errorRange;

var _expandList2 = require('./_expand-list');

var _expandList3 = _interopRequireDefault(_expandList2);

var _applyRange2 = require('./_apply-range');

var _applyRange3 = _interopRequireDefault(_applyRange2);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function errorRange(root, listName, start, end, error) {
    var update = function update(entry) {
        return (0, _extends3.default)({}, entry, { state: _constants.ERROR, error: error });
    };

    root = (0, _expandList3.default)(root, listName, end);

    return (0, _applyRange3.default)(root, listName, start, end, update);
}